export {};

declare global {
  interface String {
    toRwandaPhone(): string;
    toRwandaPhoneWithoutCountryCode(): string;
    addRwandaCountryCodeToPhone(): string;
    isRwandaPhone(): boolean;
  }
}

String.prototype.isRwandaPhone = function (): boolean {
  try {
    if (!this) return false;
    const phone = this.toString();

    return (
      phone.startsWith("+250") ||
      phone.startsWith("250") ||
      phone.startsWith("078") ||
      phone.startsWith("079") ||
      phone.startsWith("072") ||
      phone.startsWith("073")
    );
  } catch (error) {
    return false;
  }
};

String.prototype.toRwandaPhone = function (): string {
  try {
    if (!this) return "";
    const originalPhone = this.toString();

    if (!this.isRwandaPhone()) {
      return originalPhone;
    }

    let cleanPhone = originalPhone;

    if (cleanPhone.startsWith("07")) {
      cleanPhone = `25${cleanPhone}`;
    } else if (cleanPhone.startsWith("+250")) {
      cleanPhone = cleanPhone.replace("+250", "250");
    } else {
      if (!cleanPhone.startsWith("250")) {
        cleanPhone = "";
      }
    }

    if (cleanPhone.length !== 12) {
      cleanPhone = "";
    }

    return cleanPhone;
  } catch (error) {
    return "";
  }
};

String.prototype.toRwandaPhoneWithoutCountryCode = function (): string {
  try {
    if (!this) return "";
    const originalPhone = this.toString();

    if (!this.isRwandaPhone()) {
      return originalPhone;
    }

    if (this.startsWith("+250")) {
      return this.replace("+250", "0");
    }

    if (this.startsWith("250")) {
      return this.replace("250", "0");
    }
    return this.toString();
  } catch (error) {
    return "";
  }
};

String.prototype.addRwandaCountryCodeToPhone = function (): string {
  try {
    if (!this) return "";
    const originalPhone = this.toString();

    if (!this.isRwandaPhone()) {
      return originalPhone;
    }

    if (this.startsWith("250")) {
      return `+${this}`;
    }

    if (this.startsWith("07")) {
      return `+250${this}`;
    }

    return this.toString();
  } catch (error) {
    return "";
  }
};
